import './PhotoShell.scss';
import React, {Component} from "react";
import {
    BrowserRouter as Router, Switch, Route
} from "react-router-dom";
import ShellShell from "./ShellShell";
import {HelmetProvider} from "react-helmet-async";

class App extends Component {
    render = () => <HelmetProvider>
        <Router>
            <Switch>
                <Route path="/:any">
                    <ShellShell/>
                </Route>
            </Switch>
        </Router>
    </HelmetProvider>
}

export default App;
